import jQuery from 'jquery';

export default function LpAPI() {
    const selectors = {
        servicesWrapper: '.services-wrapper',
        servicesPaginate: '#servicesPagination',

        postsWrapper: '.posts-wrapper',
        postsPaginate: '#postsPagination',

        recruitmentsWrapper: '.recruitments-wrapper',
        recruitmentsPaginate: '#recruitmentsPagination',
    };

    this.init = () => {
        const paged = this.getQueryParam('paged') || 1;
        this.handlePosts();
        this.handleRecruitments();

        this.displayServices('', parseInt(paged), 'vi');
    };

    this.handleRecruitments = () => {
        let search = '';
        let paged = 1;
        let lang = 'vi';

        this.displayRecruitments( search, paged, lang );
    }

    this.displayRecruitments = async ( search = '', paged = 1, lang) => {
        let wrapper = document.querySelector(selectors.recruitmentsWrapper);
        if (!wrapper) return;

        lang = wrapper.getAttribute('data-current-lang');
        paged = wrapper.getAttribute('data-current-paged');

        let paginate = document.querySelector(selectors.recruitmentsPaginate);
        this.toggleLoader(wrapper, true);

        await this.getRecruitments( search, paged, lang).then((res) => {
            const recruitments = res.recruitments;

            if (recruitments.length > 0) {
                let html = '';
    
                for (let i in recruitments) {
                    let item_data = recruitments[i];
                    let itemTemplate = this.templateRecruitment(item_data);
                    html += itemTemplate;
                }
                wrapper.innerHTML = html;
            
                paginate.innerHTML = this.pagination(
                    parseInt(res.pagination.current),
                    res.pagination.total
                );
                this.handleRecruitmentsPagination();
            }
    
            this.toggleLoader(wrapper, false);
        });
    };
    this.getRecruitments = async (search = '', paged = 1, lang = 'vi') => {
        return jQuery.ajax({
            type: 'GET',
            dataType: 'JSON',
            url: theme_object.endpoint_url + 'recruitments',
            data: {
                q: search,
                paged: paged,
                lang: lang
            },
            context: this,
        });
    };

    this.templateRecruitment = (data) => {
        return `
            <div class="group px-w20p py-w32p border-b border-navline first:border-t flex justify-between items-center flex-wrap hover:bg-gray">
                <div class="w-auto shrink-0">
                    <p class="text-w-xl font-semibold text-black">
                        <a href="${data.link}" class="hover:text-primary">${data.title}</a>
                    </p>
                    <p class="mt-w8p text-w-base font-normal text-sub">
                        ${data.detail}
                    </p>
                </div>
                <div class="flex-1 flex justify-end items-center gap-x-w30p">
                    <p class="min-w-w172p text-w-base text-black font-normal">
                        ${data.deadline_text}: ${data.deadline}
                    </p>
                    <a href="${data.link}" class="min-w-w221p px-w20p py-w15p text-w-sm font-normal bg-main text-white inline-flex justify-center items-center rounded-w5p drop-shadow-btnmore duration-300 hover:bg-primary">
                        ${data.seemore}
                    </a>
                </div>
            </div>
        `;
    };

    this.handleRecruitmentsPagination = () => {
        let isApiInProgress = false;
        const paginate = document.querySelector(selectors.recruitmentsPaginate);
        if (paginate) {
            let pageElements = paginate.querySelectorAll('a[data-page]');
            pageElements.forEach((page) => {
                page.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!isApiInProgress) {
                        isApiInProgress = true;

                        const paged = parseInt(page.getAttribute('data-page'));
                        let wrapper = document.querySelector(selectors.recruitmentsWrapper);
                        wrapper.setAttribute('data-current-paged', parseInt(paged));

                        this.displayRecruitments('', paged).finally(() => {
                            isApiInProgress = false;
                        });
                    }

                })
            })
        }
    };


    this.handlePosts = () => {
        let category = '';
        let search = '';
        let lang = 'vi';
        let paged = 1;

        const form = document.getElementById('searchNews');
        if (form){
            const categoryInput = form.querySelector('input[name="category"]');
            const searchInput = form.querySelector('input[name="search"]');
            const pagedInput = form.querySelector('input[name="paged"]');
            const langInput = form.querySelector('input[name="lang"]');

            category = categoryInput ? categoryInput.value : category;
            search = searchInput ? searchInput.value : search;
            paged = pagedInput ? pagedInput.value : paged;
            lang = langInput ? langInput.value : lang;

            form.addEventListener('submit', (e) => {
                e.preventDefault();

                category = categoryInput ? categoryInput.value : category;
                search = searchInput ? searchInput.value : search;
                paged = pagedInput ? pagedInput.value : paged;
                lang = langInput ? langInput.value : lang;

                this.displayPosts(category, search, paged, lang);
            })
        }

        this.displayPosts(category, search, paged, lang);
    }

    this.displayPosts = async (category = '', search = '', paged = 1, lang = 'vi') => {
        let wrapper = document.querySelector(selectors.postsWrapper);
        if (!wrapper) return;

        let paginate = document.querySelector(selectors.postsPaginate);
        this.toggleLoader(wrapper, true);
    
        await this.getPosts(category, search, paged, lang).then((res) => {
            const posts = res.posts;
            if (posts.length > 0) {
                let html = '';
    
                for (let i in posts) {
                    let item_data = posts[i];
                    let itemTemplate = this.templatePost(item_data);
                    html += itemTemplate;
                }
                wrapper.innerHTML = html;
    
                paginate.innerHTML = this.pagination(
                    parseInt(res.pagination.current),
                    res.pagination.total
                );
                this.handlePostsPagination();
            }
    
            this.toggleLoader(wrapper, false);
        });
    };

    this.getPosts = async (category = '', search = '', paged = 1, lang = 'vi') => {
        return jQuery.ajax({
            type: 'GET',
            dataType: 'JSON',
            url: theme_object.endpoint_url + 'posts/category_slug/' + category,
            data: {
                q: search,
                paged: paged,
                lang: lang
            },
            context: this,
        });
    };

    this.templatePost = (data) => {
        return `
            <div class="group w-full">
                <a href="${data.link}" class="relative flex w-full h-0 pt-[67.56%] rounded-w10p overflow-hidden">
                    <img src="${data.thumbnail}" alt="${data.title}" class="absolute inset-0 w-full h-full object-cover duration-300 group-hover:scale-110">
                </a>
                <div class="mt-w17p">
                    <p class="text-w-sm font-medium text-primary-dark">
                        ${data.date}
                    </p>
                    <p class="mt-w8p text-w-lg font-semibold text-black">
                        <a href="${data.link}" class="hover:text-primary">
                            ${data.title}
                        </a>
                    </p>
                </div>
            </div>
        `;
    };

    this.handlePostsPagination = () => {
        let isApiInProgress = false;
        const paginate = document.querySelector(selectors.recruitmentsPaginate);
        if (paginate) {
            let pageElements = paginate.querySelectorAll('a[data-page]');
            pageElements.forEach((page) => {
                page.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!isApiInProgress) {
                        isApiInProgress = true;
                        const paged = parseInt(page.getAttribute('data-page'));

                        let category = '';
                        let search = '';
                        let lang = 'vi';

                        const form = document.getElementById('searchNews');
                        if (form){
                            const categoryInput = form.querySelector('input[name="category"]');
                            const searchInput = form.querySelector('input[name="search"]');
                            const pagedInput = form.querySelector('input[name="paged"]');
                            const langInput = form.querySelector('input[name="lang"]');
                            pagedInput.value = paged;

                            category = categoryInput ? categoryInput.value : category;
                            search = searchInput ? searchInput.value : search;
                            lang = langInput ? langInput.value : lang;
                        }
    
                        this.displayPosts(category, search, parseInt(paged), lang).finally(() => {
                            isApiInProgress = false;
                        });
                    }

                })
            })
        }
    };


    this.displayServices = async (search = '', paged = 1, lang = 'vi') => {
        let wrapper = document.querySelector(selectors.servicesWrapper);
        if (!wrapper) return;

        lang = wrapper.getAttribute('data-current-lang');
        paged = wrapper.getAttribute('data-current-paged');

        let paginate = document.querySelector(selectors.servicesPaginate);
        this.toggleLoader(wrapper, true);

        await this.getServices(search, paged, lang).then((res) => {
            const services = res.services;
            if (services.length > 0) {
                let html = '';

                for (let i in services) {
                    let item_data = services[i];
                    let itemTemplate = this.templateService(item_data);
                    html += itemTemplate;
                }
                wrapper.innerHTML = html;

                paginate.innerHTML = this.pagination(
                    parseInt(res.pagination.current),
                    res.pagination.total
                );
                this.handlePagination();
            }

            this.toggleLoader(wrapper, false);
        });
    };

    this.toggleLoader = (wrapper, show) => {
        const loader = wrapper;
        if (show) {
            loader.classList.add('spinner');
        } else {
            loader.classList.remove('spinner');
        }
    };

    this.templateService = (data) => {
        return `
            <div class="group w-full">
                <a href="${data.link}" class="flex relative w-full h-0 pt-[53.286%] child-frame rounded-w20p overflow-hidden">
                    <img src="${data.thumbnail}" alt="${data.title}" class="bg-white-light duration-300 group-hover:scale-110">
                </a>
                <div class="mt-w16p">
                    <p class="fieldstyle text-w-xl2 text-primary font-semibold capitalize">
                        <a href="${data.link}" class="hover:text-main">${data.title}</a>
                    </p>
                    <div class="mt-w10p first:mt-0 text-w-base font-normal text-body">
                        ${data.excerpt}
                    </div>
                </div>
            </div>
        `;
    };

    this.getServices = async (search, paged = 1, lang = 'vi') => {
        return jQuery.ajax({
            type: 'GET',
            dataType: 'JSON',
            url: theme_object.endpoint_url + 'services',
            data: {
                q: search,
                paged: paged,
                lang: lang,
            },
            context: this,
        });
    };

    this.handlePagination = () => {
        let isApiInProgress = false;
        const paginate = document.querySelector(selectors.servicesPaginate);
        if (paginate) {
            let pageElements = paginate.querySelectorAll('a[data-page]');

            pageElements.forEach((page) => {
                page.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!isApiInProgress) {
                        isApiInProgress = true;
                        const paged = parseInt(page.getAttribute('data-page'));
                        let wrapper = document.querySelector(selectors.servicesWrapper);
                        wrapper.setAttribute('data-current-paged', parseInt(paged));

                        this.displayServices('', parseInt(paged), 'vi').finally(() => {
                            isApiInProgress = false;
                        });
                    }
                })
            })
        }
    };

    this.pagination = (currentPage, totalPages) => {
        if (totalPages == 1) return '';

        let paginationHTML = '';
        let display;
        let next = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M1.01341 1L7 7L1.01341 13"stroke=#4D5761 stroke-linecap=round /></svg>';
        let prev = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M6.98659 1L1 7L6.98659 13"stroke=#4D5761 stroke-linecap=round /></svg>';

        // Previous button
        if (currentPage > 1) {
            paginationHTML += `<a href="#" data-page="${currentPage - 1}" class="prev page-number">${prev}</a>`;
        }
        // First page
        if (currentPage > 2) {
            paginationHTML += `<a href="#" data-page="1" class="page-number">1</a>`;
        }

        // Ellipsis before current page range
        if (currentPage > 3) {
            paginationHTML += `<span class="dots page-number">...</span>`;
        }

        // Page numbers around the current page
        let startPage = Math.max(1, currentPage - 1);
        let endPage = Math.min(totalPages, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            display = i;
            if (i === currentPage) {
                paginationHTML += `<span class="active page-number">${display}</span>`;
            } else {
                paginationHTML += `<a href="#" data-page="${i}" class="page-number">${display}</a>`;
            }
        }

        // Ellipsis after current page range
        if (currentPage < totalPages - 2) {
            paginationHTML += `<span class="dots page-number">...</span>`;
        }

        // Last page
        if (currentPage < totalPages - 1) {
            display = totalPages;
            paginationHTML += `<a href="#" data-page="${totalPages}" class="page-number">${display}</a>`;
        }

        // Next button
        if (currentPage < totalPages) {
            paginationHTML += `<a href="#" data-page="${currentPage + 1}" class="next page-number">${next}</a>`;
        }

        return paginationHTML;
    };

    this.getQueryParam = (param) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    };

    this.updateQueryParam = (key, value) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set(key, value);
        return `${window.location.pathname}?${urlParams.toString()}`;
    };
}
